<template>
  <div :style="{ margin: '2rem' }">
    <v-card>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <v-sheet class="pa-5">
            <v-switch
              v-model="showMenuReserves"
              inset
              label="Mostrar Menu de Reservas"
            ></v-switch>
          </v-sheet>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-sheet class="pa-5">
            <v-switch
              v-model="syncSienge"
              inset
              label="Sincronização com Sienge"
            ></v-switch>
          </v-sheet>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-sheet class="pa-5">
            <v-switch
              v-model="docObrigatory"
              inset
              label="Documento do cliente obrigatório"
            ></v-switch>
          </v-sheet>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-sheet class="pa-5">
            <v-switch
              v-model="conjugateData"
              inset
              label="Solicitar dados do cônjuge"
            ></v-switch>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import api from '@/services/api'
import message from '@/utils/message'
import store from '@/store'

export default {
  name: 'config',
  data () {
    return {
      showMenuReserves: null,
      syncSienge: null,
      docObrigatory: null,
      conjugateData: null
    }
  },

  created () {
    this.showMenuReserves = store.getters.config.showMenuReserves
    this.syncSienge = store.getters.config.syncSienge
    this.docObrigatory = store.getters.config.docObrigatory
    this.conjugateData = store.getters.config.conjugateData
  },

  watch: {
    'showMenuReserves' (_newValue, oldValue) {
      if (oldValue !== null) {
        this.updateMenuReserve()
      }
    },
    'syncSienge' (_newValue, oldValue) {
      if (oldValue !== null) {
        this.updateSyncSienge()
      }
    },
    'docObrigatory' (_newValue, oldValue) {
      if (oldValue !== null) {
        this.updateDocObrigatory()
      }
    },
    'conjugateData' (_newValue, oldValue) {
      if (oldValue !== null) {
        this.updateConjugateData()
      }
    }
  },

  methods: {
    async updateMenuReserve () {
      try {
        await api.put('/configs/1', { value: this.showMenuReserves })
        message.success('Configuração atualizada')
        this.$store.commit('setShowMenuReserve', this.showMenuReserves)
      } catch (error) {
        message.error('Erro ao atualizar configuração')
      }
    },
    async updateSyncSienge () {
      try {
        await api.put('/configs/2', { value: this.syncSienge })
        message.success('Configuração atualizada')
        this.$store.commit('setSyncSienge', this.syncSienge)
      } catch (error) {
        message.error('Erro ao atualizar configuração')
      }
    },
    async updateDocObrigatory () {
      try {
        await api.put('/configs/3', { value: this.docObrigatory })
        message.success('Configuração atualizada')
        this.$store.commit('setDocObrigatory', this.docObrigatory)
      } catch (error) {
        message.error('Erro ao atualizar configuração')
      }
    },
    async updateConjugateData () {
      try {
        await api.put('/configs/4', { value: this.conjugateData })
        message.success('Configuração atualizada')
        this.$store.commit('setConjugateData', this.conjugateData)
      } catch (error) {
        message.error('Erro ao atualizar configuração')
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/configs/Config.vue